export default __webpack_public_path__ + "static/media/weather-sun.927ac64d.webp";